import React, { useState, useEffect } from 'react';

const TestHtmlRenderer: React.FC = () => {
  const [htmlContent, setHtmlContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const fetchHtmlFile = async () => {
      try {
        setLoading(true);
        const response = await fetch('/test.html');
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const html = await response.text();
        setHtmlContent(html);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load HTML file');
      } finally {
        setLoading(false);
      }
    };

    fetchHtmlFile();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading HTML file...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        color: 'red',
        fontSize: '18px'
      }}>
        Error: {error}
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <iframe
        src="/test.html"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          overflow: 'auto'
        }}
        title="Test HTML Page"
      />
    </div>
  );
};

export default TestHtmlRenderer; 